module.exports = __webpack_public_path__ + "static/media/and_scr_onboarding_01.f8318480.png";